<form autocomplete="off" [formGroup]="consumidorForm" (ngSubmit)="onSubmit()">

<span *ngIf="!validarForm">
  <div class="row">
    <div class="col-sm-6 offset-sm-3">
      <div class="card">
        <div class="card-header">
          <strong>Cadastre-se</strong>
        </div>
        <br>
        <div class="row" *ngIf="mensagemErro">
          <div class="col-sm-12">
            <div class="alert alert-danger" role="alert">
              {{mensagemErro}}
            </div>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="cpf">CPF</label>
                <input type="text" 
                      class="form-control"
                      name="cpf"
                      id="cpf"
                      placeholder="Digite o seu CPF"
                      formControlName="cpf"
                      [textMask]="maskCPF"
                      (keyup)="LimparErros($event)">

                <div *ngFor="let error of formErrors.cpf" class="alert alert-danger">
                  {{ error }}
                </div>
              </div>
            </div>
          </div>
          <!--/.row-->

          
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="dataNascimento">Data de Nascimento</label>
                  <div class="form-group">
                      <input class="form-control" 
                            id="dataNascimento" 
                            name="dataNascimento" 
                            placeholder="dd/mm/aaaa"
                            formControlName="dataNascimento"
                            [textMask]="maskData"
                            (keyup)="LimparErros($event)">
                  </div>                            

                <div *ngFor="let error of formErrors.dataNascimento" class="alert alert-danger">
                  {{ error }}
                </div>

              </div>
            </div>
          </div>
          <!--/.row-->

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="nomeMae">Nome da Mãe</label>
                  <input type="text"
                        class="form-control"
                        name="nomeMae"
                        id="nomeMae"
                        formControlName="nomeMae"
                        placeholder="Digite o Nome da Mãe"
                        maxlength="80"
                        AlphaOnly="true"
                        (keyup)="LimparErros($event)"
                        onpaste="return false;"> 
                  <div *ngFor="let error of formErrors.nomeMae" class="alert alert-danger">
                    {{ error }}
                  </div>       
              </div>
            </div>
          </div>
          <!--/.row-->

          <div class="row" *ngIf="this.useRecaptcha">
            <div class="col-sm-12 section-block small-text" style="font-size: 11px;">
              <re-captcha (resolved)="resolved($event)" siteKey="{{ recaptcha }}"></re-captcha>
            </div>
          </div>
          <!--/.row-->
          
        <br>
          <div class="row">

            <div class="col-6">
              <button 
                type="submit" 
                class="btn btn-bluelight"               
                [disabled]="!validCPF || !validRecaptcha || !consumidorForm.valid"
                data-toggle="tooltip" data-placement="top" title="Cadastrar">Cadastrar</button>
            </div>
            
            <div class="col-6 text-right">
              <a routerLink="/consumidor" class="btn btn-link">Já é cadastrado?</a>
            </div>            
          </div>
          <!--/.row-->
        </div>
      </div>
    </div>
    <!--/.col-->
  </div>
</span>


<span *ngIf="validarForm">
  <h2>Cadastro na Campanha Nota Premiada Bahia</h2>
  <p>Este cadastro não esta utilizando vínculo de divulgação</p>  
  
  <h4>Validações complementares</h4>
  <p>Estas informações são necessárias para garantir a segurança do seu cadastro.</p>  

  <div class="row">
    <div class="col-sm-6 offset-sm-3">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="nomeMae">Nome da Mãe</label>
                  <input type="text"
                        class="form-control"
                        name="nomeMae"
                        id="nomeMae"
                        formControlName="nomeMae"
                        maxlength="80"> 
                  <div *ngFor="let error of formErrors.nomeMae" class="alert alert-danger">
                    {{ error }}
                  </div>       
              </div>
            </div>
          </div>
          <!--/.row-->
          <div class="row">
            <div class="col-sm-12">
              <button 
                type="button"
                class="btn btn-success" 
                (click)="validarFormConsumidor()"
                [disabled]="!consumidorForm.valid"
              >Validar Dados</button>
            </div>
          </div>
          <!--/.row-->
        </div>
        <!--/.card-body-->
      </div>
    </div>
  </div>
</span>


</form>






// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-cadastrar/consumidor-cadastrar.component.html